import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { CreatePlanRequest, PlanResponse } from '../types/domain';

export function planEndpoints(http: HttpClient) {
  return {
    list: () => http.get<ApiEnvelope<PlanResponse[]>>('/v1/plans').then(unwrap),
    create: (body: CreatePlanRequest) => http.post<ApiEnvelope<PlanResponse>>('/v1/plans', body).then(unwrap),
    update: (id: string, body: Partial<CreatePlanRequest> & { isActive?: boolean }) => http.put<ApiEnvelope<PlanResponse>>(`/v1/plans/${id}`, body).then(unwrap),
    remove: (id: string) => http.del<ApiEnvelope<void>>(`/v1/plans/${id}`).then(unwrap),
  };
}
export type PlanEndpoints = ReturnType<typeof planEndpoints>;
